import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api/axios";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setMessage("");

    if (newPassword.length < 8) {
      setMessage("Password must be at least 8 characters.");
      setIsError(true);
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      setIsError(true);
      return;
    }

    setLoading(true);
    try {
      await api.post("/auth/reset-password", { newPassword });
      setIsError(false);
      setMessage("Password updated successfully! Redirecting to login...");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setIsError(true);
      setMessage(err.response?.data?.error || "Failed to update password. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      {/* Left brand panel */}
      <div className="login-brand-panel">
        <div className="login-brand-logo">🌋</div>
        <div className="login-brand-title">Set Your New Password</div>
        <div className="login-brand-tagline">
          For your security, please set a new password before continuing to your dashboard.
        </div>
        <div className="login-brand-features" style={{ marginTop: 32 }}>
          <div className="login-brand-feature">
            <span>🔑</span> Use at least 8 characters
          </div>
          <div className="login-brand-feature">
            <span>🔒</span> Mix letters, numbers &amp; symbols
          </div>
          <div className="login-brand-feature">
            <span>🚫</span> Don't reuse old passwords
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="login-form-panel">
        <div className="login-box">
          <h1>Set a new password</h1>
          <p className="subtitle" style={{ marginBottom: 24 }}>
            This is required on your first login. Choose a strong password.
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label className="form-label">New Password</label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Minimum 8 characters"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  minLength={8}
                  autoComplete="new-password"
                  autoFocus
                />
                <button
                  type="button"
                  className="input-eye-btn"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                placeholder="Re-enter password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </div>

            {/* Password strength hint */}
            {newPassword && (
              <div style={{ marginBottom: 16, fontSize: 12, color: newPassword.length >= 8 ? "var(--success)" : "var(--warning)" }}>
                {newPassword.length < 8
                  ? `${8 - newPassword.length} more characters needed`
                  : "✓ Length requirement met"}
              </div>
            )}

            <button className="btn" style={{ width: "100%" }} type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>

            {message && (
              <div className={isError ? "error-text" : "success-text"}>
                {message}
              </div>
            )}
          </form>

          <div className="divider" style={{ margin: "20px 0" }} />
          <p style={{ fontSize: 13, color: "var(--muted)", margin: 0 }}>
            <Link to="/login">← Back to Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
